import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [suscripcion, setSuscripcion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [susLoading, setSusLoading] = useState(true);

  const cargarSuscripcion = useCallback(async () => {
    setSusLoading(true);
    try {
      const r = await axios.get(`${API}/mi-suscripcion`);
      setSuscripcion(r.data);
    } catch {
      setSuscripcion(null);
    } finally {
      setSusLoading(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get(`${API}/me`)
        .then(r => {
          setUser(r.data);
          cargarSuscripcion();
        })
        .catch(() => {
          logout();
          setSusLoading(false);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
      setSusLoading(false);
    }
  }, [cargarSuscripcion]);

  const login = async (email, password) => {
    const form = new URLSearchParams();
    form.append('username', email);
    form.append('password', password);
    const r = await axios.post(`${API}/login`, form);
    localStorage.setItem('token', r.data.access_token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${r.data.access_token}`;
    setUser({ email, nombre: r.data.nombre, rol: r.data.rol, empresa_id: r.data.empresa_id });
    await cargarSuscripcion();
    return r.data;
  };

  // Guarda un token obtenido externamente (ej: registro de empresa)
  const loginConToken = async (tokenData) => {
    localStorage.setItem('token', tokenData.access_token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${tokenData.access_token}`;
    setUser({
      email: tokenData.email || '',
      nombre: tokenData.nombre,
      rol: tokenData.rol,
      empresa_id: tokenData.empresa_id,
    });
    await cargarSuscripcion();
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    setSuscripcion(null);
    setSusLoading(false);
  };

  // Activa si estado es 'activa' o 'trial'; 'pendiente'/'vencida' = inactiva
  const suscripcionActiva = suscripcion && ['activa', 'trial'].includes(suscripcion.estado);
  const diasRestantes = suscripcion?.dias_restantes ?? null;

  return (
    <AuthContext.Provider value={{
      user, login, loginConToken, logout,
      loading, susLoading, API,
      suscripcion, suscripcionActiva, diasRestantes,
      cargarSuscripcion,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
